import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";
import NtSectionButton from "../general/NtSectionButton";
import NtSectionDescription from "../general/NtSectionDescription";
import NtSectionTitle from "../general/NtSectionTitle";
import { useNavigation } from "@react-navigation/native";
import routes from "../../../navigation/routes";

function NtHomeMilitarySection(props) {
  const isMobile = useMobile();
  const nav = useNavigation();
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{
          backgroundColor: "#181818",
          borderRadius: 10,
          padding: 20,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Image
            style={[
              {
                width: 30,
                height: 30,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/flag-black.png")}
          />
          <NtSectionTitle
            style={{
              textAlign: "center",
              marginLeft: 10,
              fontWeight: "700",
            }}
          >
            Secure Communications for federal goverment and military deployments
          </NtSectionTitle>
        </View>

        <View
          style={{
            backgroundColor: "#3c3c3c",
            height: 1,
            width: "100%",
            marginTop: 20,
          }}
        />

        <NtSectionDescription style={{ marginTop: 10 }}>
          Secure communications for federal and military deployments ensure
          encrypted, reliable, and real-time information exchange. Built to
          withstand cyber threats, we support mission-critical operations with
          robust protection and compliance.
        </NtSectionDescription>

        <View
          style={{ width: "100%", alignItems: "flex-start", marginTop: 40 }}
        >
          <NtSectionButton
            title={"More Info"}
            icon={"arrow-right"}
            color="white"
            onPress={() => {
              nav.navigate(routes.gov);
            }}
          />
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtHomeMilitarySection;
